<script>
  import Checkbox2 from "../../components/input/Checkbox2.svelte";
  import RadioGroup from "../../components/input/RadioGroup.svelte";
</script>

<div style="height: 100%; padding: 5rem; background-color: white">
  <h3>Checkboxes</h3>

  <h4>Medium sized</h4>
  <div style="display: inline-flex; gap: 1rem; align-items: center; margin: 1rem;">
    <Checkbox2 checked={true}>
      Checkbox (checked)
    </Checkbox2>
    <Checkbox2 checked={false}>
      Checkbox (unchecked)
    </Checkbox2>
    <Checkbox2 checked={true} disabled={true}>
      Checkbox (disabled checked)
    </Checkbox2>
    <Checkbox2 checked={false} disabled={true}>
      Checkbox (disabled unchecked)
    </Checkbox2>
  </div>

  <h3>Radiobuttons</h3>

  <h4>Medium sized</h4>
  <div style="display: inline-flex; gap: 1rem; align-items: center; margin: 1rem;">
    <RadioGroup value="1" options={[{value: "1", text: "1"}, {value: "2", text: "2"}, {value: "3", text: "3"}]}/>

    <RadioGroup
      value="1"
      disabled={true}
      options={[{value: "1", text: "1"}, {value: "2", text: "2"}, {value: "3", text: "3"}]}
    />

    <RadioGroup
      value="1"
      options={[{value: "1", text: "1"}, {value: "2", text: "2"}, {value: "3", text: "3", disabled: true}]}
    />

  </div>
</div>
